var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 21,
    viewBox: "0 0 15.75 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-bulb",
    "data-name": "Icon ionic-md-bulb",
    d: "M12.25,24.406A1.1,1.1,0,0,0,13.344,25.5h4.812a1.1,1.1,0,0,0,1.094-1.094v-.984h-7ZM15.75,4.5a7.607,7.607,0,0,0-7.875,7.328,7.232,7.232,0,0,0,3.358,6.048V20.25a1.093,1.093,0,0,0,1.127,1.05h6.776a1.09,1.09,0,0,0,1.127-1.05V17.877a7.224,7.224,0,0,0,3.363-6.048A7.607,7.607,0,0,0,15.75,4.5Z",
    transform: "translate(-7.875 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulb);
export default __webpack_public_path__ + "static/media/icon-bulb.62455b3e9d9bf75762c73c250edc33fa.svg";
export { ForwardRef as ReactComponent };